import { SocialNetworksImageSharingAgreementItem } from 'types';

export const socialNetworksLabels: Record<SocialNetworksImageSharingAgreementItem, string> = {
    facebook: 'Facebook',
    instagram: 'Instagram',
    tiktok: 'TikTok',
    website: 'Strona placówki',
};
